export const virtkbd = () => {
    var _a, _b, _c, _d, _e;
    const uaDataMobile = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile;
    if (uaDataMobile === true) {
        return true;
    }
    const ua = navigator.userAgent;
    const uaLooksHandheld = /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua);
    const coarsePointer = (_c = (_b = window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, "(pointer: coarse)").matches) !== null && _c !== void 0 ? _c : false;
    const noHover = (_e = (_d = window.matchMedia) === null || _d === void 0 ? void 0 : _d.call(window, "(hover: none)").matches) !== null && _e !== void 0 ? _e : false;
    const hasTouch = navigator.maxTouchPoints > 0;
    return uaLooksHandheld || (coarsePointer && noHover && hasTouch);
};
